module.exports = __webpack_public_path__ + "static/media/AdminNómina_ExcepciónMontos.f519f193.svg";